import { FC } from "react";

import { useFilters } from "@hooks/useFiltersQuery";

import { TCategoryFilterButton } from "@store/actions/quickFilters";
import { useAppSelector } from "@store/hooks";
import { getCategoriesFilterButtons } from "@store/selectors/quickFilters";

import { useQueryParam } from "use-query-params";

import { CategoryButton, CategoryButtonsWrapper } from "./components";

export const CategoryButtons: FC = () => {
  const [category] = useQueryParam("quickFiltersCategory");
  const quickCategories = useAppSelector(getCategoriesFilterButtons);
  const { handleSetQuery } = useFilters();

  const renderCategory = ({ title, _id }: TCategoryFilterButton) => (
    <CategoryButton $isSelected={category === _id} onClick={() => handleSetQuery({ quickFiltersCategory: _id })}>
      {title}
    </CategoryButton>
  );

  return (
    <CategoryButtonsWrapper>
      <CategoryButton $isSelected={!category} onClick={() => handleSetQuery({ quickFiltersCategory: undefined })}>
        All
      </CategoryButton>
      {quickCategories.map(renderCategory)}
    </CategoryButtonsWrapper>
  );
};
